import axios from 'axios';

import { apiBaseUrl } from '@/environment/environment';

import { AppStorage } from '@/app/shared/services/app-storage/app-storage.js';
import router from '@/app/app-routes'
import { EventBus } from '@/app/shared/services/event-bus.js';

/**
 * Axios basic configuration
 * Some general configuration can be added like timeout, headers, params etc. More details can be found on https://github.com/axios/axios
 * */
let storage = new AppStorage();

//let config = {
//    baseURL: apiBaseUrl,
//    headers: {
//        'Authentication':
//            storage.getItem('Token') == null ? "" : storage.getItem('Token').Value, 'Content-Type': 'application/json'
//    }

//};

function getConf(isStream = false) {
    if (isStream == true) {
        return {
            baseURL: apiBaseUrl,
            withCredentials: true,
            responseType: "arraybuffer",
            headers: {
                'Authentication':
                    storage.getItem('Token') == null ? "" : storage.getItem('Token').Value, 'Content-Type': 'application/json'
            }

        };

    }
    else {
        return {
            baseURL: apiBaseUrl,
            withCredentials: true,
            headers: {
                'Authentication':
                    storage.getItem('Token') == null ? "" : storage.getItem('Token').Value, 'Content-Type': 'application/json'
            }

        };
    }

}


const loginConfig = {
    baseURL: null,
    withCredentials: true,
    crossDomain: true,
    headers: {

    },

};

/**
 * Creating the instance of Axios
 * It is because, in large scale application we may need to consume APIs from more than single server,
 * So, may need to create multiple http client with different config
 * Only this client will be used rather than axios in the application
 **/

let httpClient = CreateHttpClient();// axios.create(getConf());

const loginHttpClient = axios.create(loginConfig);

//create client with its interceptor
function CreateHttpClient(isStream = false) {
    let http = axios.create(getConf(isStream));
    http.interceptors.response.use(
        response => {
            EventBus.$emit('HideLoader');
            return response;
        },
        error => {
            EventBus.$emit('HideLoader');
            debugger
            if (error.config.errorHandle === true) {
                return Promise.reject(error);
            }
            if (error.response) {
                EventBus.$emit('HideLoader');
                var stauts = error.response.status;
                //error.response.data


                if (stauts === 500 || error.response.data?.ExceptionMessage) {

                    if (error.response.data?.ExceptionMessage != null) {
                        if (error.response.data?.ExceptionType && error.response.data?.ExceptionType.indexOf("AutomaticJECreationException") !== -1) {
                            EventBus.$emit('InternalServerError', error.response.data?.ExceptionMessage, error.response.data?.ExceptionType);
                        }
                        else {
                            EventBus.$emit('InternalServerError', error.response.data?.ExceptionMessage);
                        }
                    }
                    else if (error.response.request.responseType == "arraybuffer") {
                        var enc = new TextDecoder("utf-8");
                        if (error.response.data != null) {
                            let val = enc.decode(error.response.data);
                            let ex = JSON.parse(val);
                            EventBus.$emit('InternalServerError', ex?.ExceptionMessage);
                        }
                    }
                    else {
                        EventBus.$emit('InternalServerError', error.response.status + ": " + error.response.data);
                    }


                    //alert(error.response.status + ": " + error.response.data?.ExceptionMessage);
                }
                if (stauts == 401) {
                    router.push('/401');
                } else if (stauts == 422) {
                    if (error.response.headers['sessionexpire'] == 'true' || (error.response.headers['expires'] != null && error.response.headers['expires'] == '-1')) {
                        EventBus.$emit('InternalServerError', error.response.status + ": " + error.response.statusText);
                        clearCasheAndRelogIn()
                    }
                    else
                        router.push('/401');
                } else if (stauts == 307) { // Session Expired 
                    clearCasheAndRelogIn()
                } else if (stauts == 303) {
                    //expired token but authorized user so regenrate a new TOKEN 
                    if (error.response.headers['expiredtoken'] == 'true') {
                        //var tokenData = clientAgentService().getTicket("Token");
                        clearCasheAndRelogIn()

                    }
                    else if (error.response.headers['expiredtoken'] == 'false') {//expired token and not authorized
                        localStorage.clear();
                        router.push('/401');
                        //$state.go("app.unauthorized");// unauthorized page                    
                    }

                } else if (stauts == 503) {
                    EventBus.$emit('InternalServerError', error.response.status + ": " + error.response.data);
                }
                else if (stauts == 0) {
                    router.push('/dashboard');
                }

            }
            /** Do something with response error */


        }
    );
    return http;
}

function refreshHttpClient() {
    httpClient = CreateHttpClient();
}
function clearCasheAndRelogIn() {
    localStorage.clear();
    router.push('/');
}
function withCredentialsClient() {
    return axios.create({
        baseURL: apiBaseUrl,
        withCredentials: true,
        crossDomain: true,
        headers: {
            'Authentication':
                storage.getItem('Token') == null ? "" : storage.getItem('Token').Value, 'Content-Type': 'application/json'
        }

    });
}

let httpClientStream = CreateHttpClient(true);

/**
 * Auth interceptors
 * @description Configuration related to AUTH token can be done in interceptors.
 * Currenlty it is just doing nothing but idea to to show the capability of axios and its interceptors
 * In future, interceptors can be created into separate files and consumed into multiple http clients
 * @param {*} config
 */
const authInterceptor = config => {
    /** add auth token */
    return config;
};

const loggerInterceptor = config => {
    /** Add logging here */
    return config;
};

/** Adding the request interceptors */
httpClient.interceptors.request.use(authInterceptor);
httpClient.interceptors.request.use(loggerInterceptor);

httpClientStream.interceptors.request.use(authInterceptor);
httpClientStream.interceptors.request.use(loggerInterceptor);

loginHttpClient.interceptors.response.use(
    response => {
        EventBus.$emit('HideLoader');

        return response;
    },
    error => {
        EventBus.$emit('HideLoader');

        if (error.config.errorHandle === true) {
            return Promise.reject(error);
        }
        if (error.response) {
            var stauts = error.response.status;
            if (stauts === 500 && error.response.data?.ExceptionMessage) {
                alert(error.response.status + ": " + error.response.data?.ExceptionMessage);
            }
        }
    }
);

export { httpClient, loginHttpClient, refreshHttpClient, withCredentialsClient, httpClientStream };
